export default "<h2 class=\"mat-h2 mstar-heading\">\n  <ng-content></ng-content>\n</h2>\n";